import { LOCAL } from "@/store/mutations";

const { ADD_RISK_SCORE } = LOCAL;

export default {
	namespaced: true,
	state: {
		scores: [],
	},
	getters: {
		average: (state) => state.scores.reduce((sum, risk) => risk + sum, 0) / state.scores.length,
	},
	actions: {
		track({ commit, rootGetters }) {
			rootGetters["game/plans/owned"].forEach((plan) => {
				commit(ADD_RISK_SCORE, { score: plan.risk });
			});
		},
	},
	mutations: {
		[ADD_RISK_SCORE](state, risk) {
			state.scores.push(risk.score);
		},
	},
};
